import '../common/base';
import Vue from './common/vue-common';
import CollectionsPage from './components/collection/CollectionsPage';
import RenderNotifier from './components/common/RenderNotifier';

new Vue({
    el: '#collections-vue',
    components: { CollectionsPage, RenderNotifier },
});
